export interface ScopedBundle {
  bundleId: string; label: string; description: string;
  routineGrantable: boolean; breakGlass: boolean; scopeTypes: string[];
}
export interface ScopedCatalog {
  catalogVersion: string; enforcementStatus: string; bundles: ScopedBundle[];
}
export interface ScopedAssignment {
  assignmentId: string;
  subject: {type: string; id: string};
  bundleId: string;
  scope: {type: string; id: string};
  lifecycle: 'scheduled' | 'effective' | 'expired' | 'revoked' | 'unknown-bundle';
  effectiveAt: string; expiresAt: string | null; createdAt: string; revokedAt: string | null;
  catalogVersionAtGrant: string;
}
export interface ScopedPage {
  assignments: ScopedAssignment[]; revision: string; nextCursor: string | null;
  catalogVersion: string; enforcementStatus: string;
}
export interface ScopedGrant {
  expectedCatalogVersion: string; bundleId: 'payroll_operations'; scope: {type: 'company'; id: string};
}
export interface ScopedMutation {
  outcome: 'granted' | 'already_active' | 'revoked' | 'already_revoked' | 'already_inactive';
  reasonCode: string; assignment: ScopedAssignment; revision: string;
  catalogVersion: string; enforcementStatus: string;
}
export interface ScopedCompany {id: string; name: string; type?: string; deletedAt?: string | null; }
export interface ScopedAccessApi {
  catalog(current: () => boolean): Promise<ScopedCatalog>;
  list(subject: string, history: boolean, cursor: string | null, current: () => boolean): Promise<ScopedPage>;
  grant(subject: string, body: ScopedGrant, key: string, current: () => boolean): Promise<ScopedMutation>;
  revoke(id: string, body: {expectedCatalogVersion: string}, key: string, current: () => boolean): Promise<ScopedMutation>;
}
export function exactScopedTarget(session: {isExactSuperAdmin(): boolean; getUserId(): string}, target: unknown): boolean {
  try {
    if (!session.isExactSuperAdmin()) { return false; }
    const actor = session.getUserId();
    return exactId(actor) && exactId(target) && actor !== target;
  } catch (_) { return false; }
}
export function exactId(value: unknown): value is string {
  return typeof value === 'string' && value.length > 0 && value.length <= 128 && /^[\x21-\x7e]+$/.test(value) && !value.includes('@');
}
